import { useCallback, useMemo } from 'react';

import { ContactGroupDetails } from 'contacts/components/ContactGroupList';
import { ContactGroupType } from 'contacts/enums';
import { IContact, IContactGroup } from 'contacts/types';
import { AgGridServerTable } from 'core/components';
import { useAgGridTableContext } from 'core/states';

import { ContactDetails } from './Details';
import {
  ChangeContactGroupingButton,
  ChangeOwnerButton,
  RemoveContactButton,
  RestoreContactButton,
} from './SelectionActions';

interface IProps {
  selectedContactGroup: IContactGroup | null;
  setSelectedContactGroup: (contactGroup: IContactGroup | null) => void;
  selectedContact: IContact | null;
  setSelectedContact: (contact: IContact | null) => void;
  groupType: ContactGroupType;
}

export const ContactListTable = ({
  selectedContactGroup,
  setSelectedContactGroup,
  selectedContact,
  setSelectedContact,
  groupType,
}: IProps) => {
  const { gridApi } = useAgGridTableContext();

  const onEditContactSuccess = (contact: IContact) => {
    setSelectedContact(contact);
    gridApi?.refreshServerSide();
  };

  const onEditContactGroupSuccess = (contactGroup: IContactGroup) => {
    setSelectedContactGroup(contactGroup);
    gridApi?.refreshServerSide({ purge: true });
  };

  const refreshTable = useCallback(() => {
    gridApi?.refreshServerSide();
  }, [gridApi]);

  const selectionActionButtons = useMemo(() => {
    return [
      <ChangeOwnerButton key="changeOwner" onSubmitSuccess={refreshTable} />,
      <ChangeContactGroupingButton key="changeContactGroup" onSubmitSuccess={refreshTable} />,
      <RemoveContactButton key="removeContact" onSubmitSuccess={refreshTable} />,
      <RestoreContactButton key="restoreContact" onSubmitSuccess={refreshTable} />,
    ];
  }, [refreshTable]);

  return (
    <>
      <AgGridServerTable selectionActionButtons={selectionActionButtons} />

      <ContactGroupDetails
        isOpen={!!selectedContactGroup}
        onClose={() => setSelectedContactGroup(null)}
        contactGroup={selectedContactGroup}
        contactGroupType={groupType}
        onEditContactGroupSuccess={onEditContactGroupSuccess}
      />

      <ContactDetails
        isOpen={!!selectedContact}
        onClose={() => setSelectedContact(null)}
        contact={selectedContact}
        contactGroupType={groupType}
        onEditContactSuccess={onEditContactSuccess}
      />
    </>
  );
};
